import { withBaseUrl } from "../config/env";

export type ApiOptions = RequestInit & { rawUrl?: boolean };

// Small wrapper around fetch to automatically prefix API base URL and include auth token.
// Usage: apiFetch('/trips/start', { method: 'POST', body: JSON.stringify(...) })
export const apiFetch = (pathOrUrl: string, options: ApiOptions = {}) => {
  const { rawUrl, ...fetchOptions } = options;
  const url = rawUrl ? pathOrUrl : withBaseUrl(pathOrUrl);

  // Get auth token from localStorage
  const token = localStorage.getItem("authToken");

  // Prepare headers
  const headers = new Headers(fetchOptions.headers);

  // Add Authorization header if token exists
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  // Return fetch with updated options
  return fetch(url, {
    ...fetchOptions,
    headers,
  });
};

export default apiFetch;
